import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import {
    Icon
} from 'antd';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
        const companyInfo = this.modulesState.companyInfo;
        return (
            <div className={css['log']}>
                <Icon className={css['log-icon']} type="drxx27"/>
                <h1>{companyInfo && companyInfo.name}</h1>
                <span>- 共{this.modulesState.treeDate && this.modulesState.treeDate[0].children.length}个一级部门 -</span>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/Organization/UI.Log.tsx